import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const StepperHeaderStep = ({ icon, label, position, selected = false, invalid = false, disabled = false }) => {
    const { t } = useTranslation('shared');
    const className = useMemo(() => {
        let cn = 'stepper__step';
        if (selected)
            cn += ' stepper__step--selected';
        if (invalid)
            cn += ' stepper__step--invalid';
        if (disabled)
            cn += ' stepper__step--disabled';
        return cn;
    }, [disabled, invalid, selected]);
    return (_jsx("li", { className: className, children: _jsxs("button", { type: "button", className: "stepper__step__btn", disabled: disabled, children: [_jsx("i", { className: `fa-light fa-${icon}` }), _jsxs("div", { className: "stepper__step__info", children: [_jsxs("p", { children: [t('common.step'), " ", position] }), _jsx("h4", { children: label })] })] }) }));
};
export default StepperHeaderStep;
